import propTypes from 'prop-types';

import { PesIcon } from '@pes-ui/components-react';
import { pesIconSizes } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';

export const BtnIcon = ({ handleClick }) => {
  const clickBtnFavHandler = (e) => {
    e.preventDefault();
    handleClick();
  };

  return (
    <button type="button" className="button-less add-to-cart-button" onClick={clickBtnFavHandler}>
      <PesIcon class="actions-block__icon" size={pesIconSizes.MICRO}>
        segment_retail
      </PesIcon>
    </button>
  );
};

BtnIcon.propTypes = {
  handleClick: propTypes.func
};

BtnIcon.defaultProps = {
  handleClick: () => {}
};
